// @ts-nocheck
import { all, call, takeLatest } from 'redux-saga/effects';
import { api } from 'store/apis';
import { invoiceActions } from 'store/invoice/invoice.actions';
import {
  transactionConstants as events,
  transactionActions,
} from 'store/transaction/transaction.actions';

import { sendApi } from '../sagas';

function* transactionWatchers() {
  yield all([
    // @ts-expect-error
    yield takeLatest(
      events.paymentHistory.request,
      sendApi(api.transactions.payment, transactionActions.paymentHistoryRes),
    ),
    // @ts-expect-error
    yield takeLatest(
      events.getReconciliationPayments.request,
      sendApi(api.transactions.payment, transactionActions.getReconciliationPaymentsRes),
    ),
    // @ts-expect-error
    yield takeLatest(
      events.paymentHistoryPage.request,
      sendApi(api.transactions.payment, transactionActions.paymentHistoryPageRes, payload => ({
        data: payload,
        noLoading: true,
      })),
    ),
    // @ts-expect-error
    yield takeLatest(
      events.getReconciliation.request,
      sendApi(api.transactions.getReconciliation, transactionActions.getReconciliationRes),
    ),
    // @ts-expect-error
    yield takeLatest(
      events.manualReconciliation.request,
      sendApi(api.transactions.manualReconciliation, transactionActions.manualReconciliationRes),
    ),
    // @ts-expect-error
    yield takeLatest(
      events.ignorePayments.request,
      sendApi(api.transactions.ignorePayments, transactionActions.ignorePaymentsRes),
    ),
    // @ts-expect-error
    yield takeLatest(
      events.unignorePayments.request,
      sendApi(api.transactions.unignorePayments, transactionActions.unignorePaymentsRes),
    ),
    // @ts-expect-error
    yield takeLatest(
      events.unmatchManualPayment.request,
      sendApi(api.transactions.unmatchManualPayment, invoiceActions.detailRes),
    ),
    // @ts-expect-error
    yield takeLatest(
      events.unmatchExternalPayment.request,
      sendApi(api.transactions.unmatchExternalPayment, invoiceActions.detailRes),
    ),
  ]);
}

export default function* saga() {
  yield call(transactionWatchers);
}
